<template>
  <client-autocomplete v-model="clientId" />
  <a v-loading="request.state.pending" class="header__report" href="#" @click.prevent="handleDownload">
    <icon-download />
    Отчет за {{ formattedDate }}
  </a>
  <div ref="pickerWrapperRef" class="header-datepicker">
    <button class="header-datepicker__toggle" @click="showPicker = !showPicker">
      <icon-calendar />
    </button>
    <transition name="fade">
      <div v-if="showPicker" class="header-datepicker__body">
        <vue-date-picker
          v-model="date"
          :time-picker="false"
          locale="ru"
          inline
          :enable-time-picker="false"
          auto-apply
          hide-offset-dates
          :range="{
            maxRange: 14
          }"
          @update:modelValue="showPicker = false"
        />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import IconDownload from '@/components/images/IconDownload.vue'
import IconCalendar from '@/components/images/IconCalendar.vue'
import ClientAutocomplete from './ClientAutocomplete.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import dayjs from 'dayjs'
import useDataRequest from '@/composables/useDataRequest'
import { downloadReport } from '@/api/order'
import { downloadFile } from '@/utils/helpers'
import store from '@/store'

const showPicker = ref(false)

const date = ref([dayjs().subtract(1, 'day').toDate(), dayjs().subtract(1, 'day').toDate()])
const clientId = ref<number|null>(null)
const pickerWrapperRef = ref()
const request = useDataRequest()

const formattedDate = computed(() => date.value.map(value => dayjs(value).format('DD.MM.YYYY')).join(' - '))

const clickListener = (event: MouseEvent) => {
  if (pickerWrapperRef.value !== event.target && !pickerWrapperRef.value.contains(event.target)) {
    showPicker.value = false
  }
}

const handleDownload = () => {
  request.tryRequest(async () => {
    const period = date.value.map(value => dayjs(value).format('YYYY-MM-DD')) as [string, string]
    const response = await downloadReport({
      period,
      client_id: clientId.value,
      region_id: store.state.regionId
    })
    const filename = 'report-' + (period[0] === period[1] ? period[0] : period.join(' - ')) + '.xls'
    downloadFile(response, filename)
  })
}

onMounted(() => {
  document.addEventListener('click', clickListener)
})

onUnmounted(() => {
  document.removeEventListener('click', clickListener)
})
</script>
